import { Component } from '@angular/core';

@Component({
  selector: 'mtm-purple-circle-icon',
  templateUrl: './purple-circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class PurpleCircleIconComponent {}
